import type { EstatusFactura, MetodoPago } from "./schemas";

export const ESTATUS_VARIANT: Record<
  EstatusFactura,
  "success" | "warning" | "destructive" | "secondary" | "default"
> = {
  pendiente: "default",
  parcial: "warning",
  pagada: "success",
  vencida: "destructive",
  anulada: "secondary",
};

export const ESTATUS_LABEL: Record<EstatusFactura, string> = {
  pendiente: "Pendiente",
  parcial: "Parcial",
  pagada: "Pagada",
  vencida: "Vencida",
  anulada: "Anulada",
};

export const METODO_LABEL: Record<MetodoPago, string> = {
  efectivo: "Efectivo",
  transferencia: "Transferencia",
  tarjeta: "Tarjeta",
  provider_automatico: "Automático",
  cheque: "Cheque",
  otro: "Otro",
};
